/**
 * Canonical store listings for the Help Genie native app. Single source of
 * truth shared by the install banner, the activation smart link, and the
 * app-onboarding sections — never hardcode these URLs inline.
 */
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/help-genie-voice/id6755985515';

export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.helpgenie.app';

/** Store badge images (under /public/email-assets). */
export const APP_STORE_BADGE_SRC = '/email-assets/app-store-badge.svg';
export const GOOGLE_PLAY_BADGE_SRC = '/email-assets/google-play-badge.png';
